var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.capacity == 'Full')?_c('img',{staticClass:"h-lg-150px float-left",attrs:{"src":require("@/assets/media/full-pink.png")}}):_vm._e(),(_vm.capacity == 'Half')?_c('img',{staticClass:"h-lg-150px float-left",attrs:{"src":require("@/assets/media/half-pink.png")}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }